import React from 'react'
import { Container, ContentHeader, LoadingBox, Page } from 'components'
import { SSOCorporateGroupForm } from './components'

import { useFetch } from 'hooks'

import * as service from 'service'

const SSOCorporateGroupEdit = ({ match }) => {
  const {
    params: { ssoCorporateGroupId },
  } = match

  const { response, isLoading, isStillLoading, refresh } = useFetch(
    service.dponet.ssoCorporateGroups.get,
    { ssoCorporateGroupId },
    [],
  )

  const ssoCorporateGroup = response?.data?.ssoCorporateGroup

  return (
    <Page title="Editar Organização SSO-SAML">
      <Container
        maxWidth={false}
        spacingXl={30}
        spacingLg={25}
        spacingMd={10}
        spacingSm={10}
      >
        <ContentHeader
          menu="Organização SSO-SAML"
          title="Editar"
          subtitle="Editar Organização SSO-SAML"
        />
        {isLoading || isStillLoading ? (
          <LoadingBox />
        ) : (
          <SSOCorporateGroupForm
            edit
            ssoCorporateGroup={ssoCorporateGroup}
            refresh={refresh}
          />
        )}
      </Container>
    </Page>
  )
}

export default SSOCorporateGroupEdit
